<template>
  <div class="bpm-list-wrapper">
    <div class="bpm-list" :id="cardType">
      <!-- CARD LIST TITLE -->
      <div class="bpm-list-header">{{cardTitle}}</div>
      <div class="bpm-list-cards">
        <!-- CARD listUrgent -->
        <div
          class="bpm-list-card"
          v-for="task in cardList"
          :key="task.key.bpm_task_id"
          @click="selectBpmTaskCard(task)"
        >
          <div class="lineA">
            <p>{{task.key.task_label}}</p>
            <p>{{task.key.data_string}}</p>
          </div>
          <p class="card-subtitle">{{task.key.process_label}}</p>
        </div>
      </div>
      <!-- CARD LIST FOOTER -->
      <div class="bpm-list-footer">{{cardList.length}} Cards</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BpmHomeCardList",
  props: {
    cardList: Array,
    cardType: String,
    cardTitle: String
  },
  components: {},
  computed: {},
  data: function() {
    return {};
  },
  methods: {
    selectBpmTaskCard(task) {
      const objTaskCard = {
        inputs: task.key.columns,
        task_label: task.key.task_label,
        process_label: task.key.process_label,
        bpm_process_id: task.key.bpm_process_id,
        bpm_process_version_id: task.key.bpm_process_version_id,
        bpm_task_id: task.key.bpm_task_id,
        bpm_process_runner_id: task.key.bpm_process_runner_id,
        task_name: task.key.task_name
      };
      this.$emit("selectedBpmTaskCard", objTaskCard);
      this.$emit("selectedBpmTaskList", task.tasklist);
    }
  },
  mounted() {},
  watch: {}
};
</script>